import { formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency, withPrimaryCurrency } from 'utils/helpers/currency/currencyHelpers';
import EmptyResult from 'components/others/EmptyResult';
import { useSettings } from 'context/SettingsContext';
import type { ReportTeamsBodyProps } from '../types';

const ReportTeamsBody = ({ teamList }: ReportTeamsBodyProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;

    return (
        <tbody>
            {teamList?.map((team) => {
                const price = formatPrice(team?.amount);
                const priceRate = formatPrice(team?.amountRate);
                const dirTeam = localSettings?.DIRS?.Team?.find((item) => item.ID == team.teamId);

                return (
                    <tr key={`${team.teamId}-team`}>
                        <td className="name">
                            <h6 className="mb-1 text-break">{dirTeam?.teamName}</h6>
                        </td>

                        <td className="income text-end" style={{ verticalAlign: 'top' }}>
                            <h6 className="mb-1 text-break">
                                {withPrimaryCurrency(price, rate)}
                            </h6>
                            {!isUahMode && (
                                <p className="text-muted f-12 mb-0 my-1">{withLocalCurrency(priceRate)}</p>
                            )}
                        </td>
                    </tr>
                );
            })}

            {!teamList?.length && (
                <tr>
                    <td colSpan={4}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ReportTeamsBody;
